import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IAoTUserSettingTemplate } from '@app/core/models/aot-usersetting-template.model';
import { AoTUsersettingTemplateForm } from '@app/core/models/forms/aot/Template/aot-usersetting-template-form.model';
import { DialogContentBase, DialogRef, DialogTitleBarComponent, DialogActionsComponent } from '@progress/kendo-angular-dialog';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormFieldComponent, TextBoxComponent, CheckBoxComponent } from '@progress/kendo-angular-inputs';
import { LabelComponent } from '@progress/kendo-angular-label';
import { ButtonComponent } from '@progress/kendo-angular-buttons';

@Component({
    selector: 'app-aot-usersetting-template',
    templateUrl: './aot-usersetting-template.component.html',
    styleUrl: './aot-usersetting-template.component.css',
    imports: [
        DialogTitleBarComponent,
        TranslateDirective,
        FormsModule,
        ReactiveFormsModule,
        FormFieldComponent,
        LabelComponent,
        TextBoxComponent,
        CheckBoxComponent,
        DialogActionsComponent,
        ButtonComponent,
        TranslatePipe,
    ],
})
export class AoTUserSettingTemplateComponent extends DialogContentBase {
  templateForm: FormGroup<AoTUsersettingTemplateForm> = new FormGroup<AoTUsersettingTemplateForm>({
    templateName: new FormControl<string>('', [Validators.required]),
    isPublic: new FormControl<boolean>(false),
  });

  constructor(private readonly dialogRef: DialogRef) {
    super(dialogRef);
  }

  save() {
    if (this.templateForm.valid) {
      const formValue = this.templateForm.value;
      const { templateName, isPublic } = formValue;

      const dto: IAoTUserSettingTemplate = {
        templateName: templateName,
        isPublic: isPublic,
      };

      this.dialogRef.close(dto);
    }
  }

  close() {
    this.dialogRef.close(false);
  }
}
